/* ==========================================================================
   Peru Balloons · Rediseño — "Explora más modelos" (final del PDP) · pb-explore.js
   Mini catálogo filtrable: en tu paleta, por tipo o todos. Cada tarjeta es un
   modelo con sus colores; se prioriza el color que combina con el producto actual.
   ========================================================================== */
(() => {
  const root = document.querySelector('[data-explore]');
  if (!root) return;
  const $ = (sel, el = document) => el.querySelector(sel);
  const $$ = (sel, el = document) => [...el.querySelectorAll(sel)];
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  const dataEl = $('#explore-data');
  const pdpEl = $('#pdp-data');
  if (!dataEl || !pdpEl) return;
  const data = JSON.parse(dataEl.textContent);
  const pdp = JSON.parse(pdpEl.textContent);
  const grid = $('[data-explore-grid]', root);
  const lead = $('[data-explore-lead]', root);
  const more = $('[data-explore-more]', root);
  const waBox = $('[data-explore-wa]', root);
  const chips = $$('[data-view]', root);
  const waPhone = ($('[data-wa-phone]') || {}).dataset?.waPhone || '51983063968';

  // El modelo que ya se está viendo no se repite (sus colores están arriba)
  const own = new Set(Object.values(pdp.products).map((p) => p.handle));
  const families = data.families.filter((f) => !f.items.some((i) => own.has(i.handle)));

  const wide = window.matchMedia('(min-width: 960px)');
  const limit = () => (wide.matches ? 8 : 6); // 2 filas en desktop, 3 en móvil
  // Paleta de cada color del producto (handle → tonos), para "En tus colores"
  data.palettes = data.palettes || Object.fromEntries(Object.entries(pdp.products).map(([k, p]) => [k, p.tones || []]));
  let key = pdp.current;
  let view = 'paleta';
  let expanded = false;

  const palette = () => data.palettes[key] || [];
  const score = (item) => item.groups.filter((g) => palette().includes(g)).length;
  const money = (n) => `S/ ${Math.round(n)}`;
  const srcset = (src) => [360, 540, 720].map((w) => `${src}&width=${w} ${w}w`).join(', ');
  const SIZES = '(min-width: 960px) 23vw, (min-width: 521px) 31vw, 46vw';

  function cardsFor(v) {
    const fams = families.filter((f) => v === 'paleta' || v === 'todos' || f.kind === v);
    let cards;
    if (v !== 'paleta' && v !== 'todos' && fams.length <= 2) {
      // Un solo modelo (p. ej. ramos de corazones): sus colores van como tarjetas
      cards = fams.flatMap((f) => f.items.map((item) => ({ f, item, s: score(item), single: true })));
    } else {
      cards = fams.map((f) => {
        const best = f.items.map((item, i) => ({ item, i, s: score(item) })).sort((a, b) => b.s - a.s || a.i - b.i)[0];
        return { f, item: best.item, s: best.s };
      });
      if (v === 'paleta') cards = cards.filter((c) => c.s > 0);
    }
    // Primero lo que combina con el color elegido arriba; luego el orden del catálogo
    return cards.map((c, i) => ({ ...c, i })).sort((a, b) => b.s - a.s || a.i - b.i);
  }

  function priceOf(f, single, item) {
    if (single) return money(item.price);
    const prices = f.items.map((i) => i.price);
    const min = Math.min(...prices);
    return min === Math.max(...prices) ? money(min) : `Desde ${money(min)}`;
  }

  const dotStyle = (item) => `--c1:${item.dot[0]};--c2:${item.dot[1] || item.dot[0]}`;

  function cardHTML({ f, item, single }, n) {
    const showDots = !single && f.items.length > 1;
    const shown = showDots ? f.items.slice(0, 5) : [];
    // Si el color elegido quedó fuera de los 5 visibles, se muestra igual
    if (showDots && !shown.includes(item)) shown[4] = item;
    return `
      <li class="explore-card" style="--i:${n}" data-family="${esc(f.name)}">
        <a class="explore-card__link" href="${esc(item.href)}" data-card-link>
          <div class="explore-card__media">
            <img class="explore-card__img" src="${esc(item.img)}&width=540" srcset="${esc(srcset(item.img))}" sizes="${SIZES}" alt="${esc(item.title)}" width="540" height="583" loading="lazy" data-card-img>
            ${item.hover ? `<img class="explore-card__img explore-card__img--hover" data-src="${esc(item.hover)}&width=540" alt="" aria-hidden="true" width="540" height="583" data-card-hover>` : ''}
          </div>
          ${f.perso ? '<p class="explore-card__eyebrow"><span class="card-tag"><svg aria-hidden="true"><use href="#i-sparkle"/></svg><span class="card-tag__text">Personalizable</span></span></p>' : ''}
          <h3 class="explore-card__title">${esc(f.name)}</h3>
          ${item.variant || showDots ? `<p class="explore-card__variant" data-card-variant>${esc(item.variant)}</p>` : ''}
        </a>
        <div class="explore-card__meta">
          <p class="explore-card__price" data-card-price>${priceOf(f, single, item)}</p>
          ${showDots ? `<div class="explore-card__dots" role="group" aria-label="Colores de ${esc(f.name)}">${shown.map((it) =>
            `<button type="button" class="explore-dot" style="${dotStyle(it)}" aria-label="${esc(it.variant)}" aria-pressed="${it === item}" data-dot="${esc(it.handle)}"></button>`).join('')}${
            f.items.length > 5 ? `<span class="explore-card__more-dots">+${f.items.length - 5}</span>` : ''}</div>` : ''}
        </div>
      </li>`;
  }

  function waHTML() {
    const color = (pdp.products[key] || {}).color || '';
    const text = `Hola, estoy viendo el ${pdp.title}${color ? ` en ${color}` : ''} y busco otro modelo. ¿Me ayudan a diseñarlo?`;
    return `
      <div class="explore-wa">
        <a class="explore-wa__link" href="https://api.whatsapp.com/send?phone=${waPhone}&text=${encodeURIComponent(text)}" target="_blank" rel="noopener">
          <span class="explore-wa__body">
            <span class="explore-wa__eyebrow"><svg aria-hidden="true"><use href="#i-sparkle"/></svg>Diseño a medida</span>
            <span class="explore-wa__title">¿Tienes otra <em>idea</em> en mente?</span>
            <span class="explore-wa__text">Cuéntanos la ocasión y tus colores: lo diseñamos contigo y te lo entregamos armado.</span>
          </span>
          <span class="explore-wa__cta">
            <span class="explore-wa__icon"><svg aria-hidden="true"><use href="#i-wa"/></svg></span>
            Escríbenos por WhatsApp
            <svg class="explore-wa__arrow" aria-hidden="true"><use href="#i-arrow-right"/></svg>
          </span>
        </a>
      </div>`;
  }

  const LEADS = {
    paleta: () => `Modelos que combinan con ${((pdp.products[key] || {}).color || '').toLowerCase()}`,
    frase: () => 'Bouquets que ya llevan su frase: cumpleaños, bienvenida y más',
    corazones: () => `Ramos de corazones en ${(families.find((f) => f.kind === 'corazones') || { items: [] }).items.length} colores`,
    deco: () => 'Decoraciones y bouquets esculturales para ambientar',
    todos: () => `Los ${families.length} modelos de ${data.collectionTitle || 'la colección'}`.replace('modelos de Globos', 'modelos de globos'),
  };

  function render({ animate = true } = {}) {
    chips.forEach((chip) => {
      const n = cardsFor(chip.dataset.view).length;
      chip.hidden = !n;
      $('[data-view-count]', chip).textContent = n;
      chip.setAttribute('aria-pressed', String(chip.dataset.view === view));
    });
    let cards = cardsFor(view);
    if (!cards.length) { view = 'todos'; cards = cardsFor(view); }
    const visible = expanded ? cards : cards.slice(0, limit());
    lead.textContent = LEADS[view]();
    grid.innerHTML = visible.map(cardHTML).join('');
    waBox.innerHTML = waHTML();
    const rest = cards.length - visible.length;
    more.hidden = rest <= 0;
    const unit = cards[0] && cards[0].single ? ['color', 'colores'] : ['modelo', 'modelos'];
    more.textContent = `Ver ${rest} ${unit[rest === 1 ? 0 : 1]} más`;
    if (animate) {
      grid.classList.remove('is-entering');
      void grid.offsetWidth;
      grid.classList.add('is-entering');
    }
  }

  chips.forEach((chip) => chip.addEventListener('click', () => {
    if (chip.dataset.view === view) return;
    view = chip.dataset.view;
    expanded = false;
    render();
  }));
  more.addEventListener('click', () => {
    expanded = true;
    render({ animate: false });
  });

  // Colores dentro de la tarjeta: cambian foto, nombre, precio y enlace sin salir de la página
  grid.addEventListener('click', (e) => {
    const dot = e.target.closest('[data-dot]');
    if (dot) {
      const card = dot.closest('.explore-card');
      const f = families.find((x) => x.name === card.dataset.family);
      const item = f.items.find((i) => i.handle === dot.dataset.dot);
      $$('[data-dot]', card).forEach((d) => d.setAttribute('aria-pressed', String(d === dot)));
      const img = $('[data-card-img]', card);
      img.src = `${item.img}&width=540`;
      img.srcset = srcset(item.img);
      img.alt = item.title;
      const hover = $('[data-card-hover]', card);
      if (hover) { hover.classList.remove('is-loaded'); hover.removeAttribute('src'); hover.dataset.src = `${item.hover}&width=540`; }
      $('[data-card-variant]', card).textContent = item.variant;
      $('[data-card-link]', card).href = item.href;
      return;
    }
    const link = e.target.closest('[data-card-link]');
    if (link) {
      (window.dataLayer = window.dataLayer || []).push({
        event: 'select_item', item_list_id: `pdp_explora_${view}`, item_list_name: 'PDP · Explora más modelos',
        items: [{ item_name: link.closest('.explore-card').dataset.family, item_variant: ($('[data-card-variant]', link) || {}).textContent || '' }],
      });
    }
  });

  // Segunda foto al pasar el mouse: se carga recién la primera vez
  grid.addEventListener('pointerover', (e) => {
    const link = e.target.closest('[data-card-link]');
    const hover = link && $('[data-card-hover]', link);
    if (!hover || hover.getAttribute('src') || !hover.dataset.src) return;
    hover.addEventListener('load', () => hover.classList.add('is-loaded'), { once: true });
    hover.src = hover.dataset.src;
  });

  // Al cambiar el color del producto arriba, "En tus colores" y el orden se recalculan
  document.addEventListener('pb:productchange', (e) => {
    key = e.detail.key;
    expanded = false;
    render({ animate: false });
  });
  wide.addEventListener('change', () => render({ animate: false }));
  render({ animate: false });
})();
